module.exports = __webpack_public_path__ + "img/traitement3.c42c2355.jpg";